import React from 'react'

import { Dashboard, PageLayout } from '@components/common'
import { LeavingGuard } from '@components/utils/LeavingGuard'
import { BackButton, Fieldset, Loading, Subsection } from '@fourthwall/components'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'
import { routing } from '@utils/routing'

import { HelpfulResources } from './components/HelpfulResources'
import { useTierContext } from './hooks/useTierContext'
import { AskForShippingAddress } from './modules/AskForShippingAddress'
import { Description } from './modules/Description'
import { Discount } from './modules/Discount'
import { DiscountType } from './modules/DiscountType/DiscountType'
import { Image } from './modules/Image'
import { InternationalPricing } from './modules/InternationalPricing'
import { MonthDiscount } from './modules/MonthDiscount'
import { Price } from './modules/Price'
import { TimeLimit } from './modules/TimeLimit'
import { Title } from './modules/Title'
import { YearDiscount } from './modules/YearDiscount'
import { TierProvider } from './providers/TierProvider'

const TierCreateContent = () => {
  const { form, isLoading, isPriceRatesLoading } = useTierContext()

  return (
    <Loading isLoading={isLoading}>
      <PageLayout
        leftContent={
          <>
            <Subsection title="Tier details">
              <Fieldset>
                <Title />
                <Description />
                <Image />
              </Fieldset>
            </Subsection>
            <Subsection title="Pricing">
              <Fieldset>
                <Price />
                <InternationalPricing />
                <Discount />
                <DiscountType />
                <MonthDiscount />
                <YearDiscount />
                <TimeLimit />
              </Fieldset>
            </Subsection>
            <Subsection title="Advanced">
              <AskForShippingAddress />
            </Subsection>
          </>
        }
        rightContent={<HelpfulResources />}
      >
        <Dashboard.Section
          name="Add a new membership tier"
          topContent={<BackButton label="Perks & tiers" to={routing.memberships.perks.self} />}
          titleSpacing="medium"
          bottomMargin="large"
        />
      </PageLayout>

      <LeavingGuard when={form.dirty} isValid={form.isValid} onSave={form.submitForm} />

      <ConfirmBar
        isOpen={form.dirty}
        isLoading={isLoading || isPriceRatesLoading}
        onConfirm={form.submitForm}
        onCancel={form.resetForm}
      />
    </Loading>
  )
}

export const TierCreate = () => {
  return (
    <TierProvider>
      <TierCreateContent />
    </TierProvider>
  )
}
